import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
/*
 * @Author: 邓鹏
 * @Date: 2026-04-15 13:54:57
 * @LastEditors: 邓鹏
 * @LastEditTime: 2026-07-03 10:21:18
 * @FilePath: /marketing-landing-fe/src/modules/landing/CourseSelection/litePlaceOrder.ts
 * @Description:
 */


import { LOCAL_BASE_URL } from '@/const';
import Toast from '@/plugins/Toast';
import { createOrder } from '@/services/landing';
import { getIsMiniProgramEnv, getRunEnvText, urlJump } from '@/utils';
import bus from '@/utils/eventemitter';
import { handleBuinessCode } from './businessCode';
import { shouldUseVirtualPayment, VIRTUAL_PAY_APP, VIRTUAL_PAY_PLATFORM } from './methods/pay';
var TRANS_PAGE = "".concat(LOCAL_BASE_URL, "/transferPage.html");
export function toCreateOrder(payload, extra) {
  var _a, _b;

  return __awaiter(this, void 0, void 0, function () {
    var sourceUrl, params, isInMiniProgram, isVirtualPay, _c, resultCode, data, errorMsg, flagCode, frontSoldNote, frontPayResp, checkCode, _d, id, needShip, _e, courseId, skuId, nsUrl, _f, preOrderId, soldId, payToken, error_1;

    return __generator(this, function (_g) {
      switch (_g.label) {
        case 0:
          sourceUrl = "".concat(window.location.href).concat(((_a = window.location.href) === null || _a === void 0 ? void 0 : _a.includes('?')) ? '&' : '?', "recommendCampaignId=").concat(extra === null || extra === void 0 ? void 0 : extra.rootCampaignId);
          params = {
            linkId: payload === null || payload === void 0 ? void 0 : payload.linkId,
            // 编码后传递
            sourceLink: encodeURIComponent(sourceUrl),
            campaignId: payload === null || payload === void 0 ? void 0 : payload.campaignId,
            skuId: payload === null || payload === void 0 ? void 0 : payload.skuId,
            campaignPageId: payload === null || payload === void 0 ? void 0 : payload.campaignPageId,
            // CHECK 新增channel 参数
            channelNo: payload === null || payload === void 0 ? void 0 : payload.channelNo,
            sourceType: getRunEnvText()
          };
          return [4
          /*yield*/
          , getIsMiniProgramEnv()];

        case 1:
          isInMiniProgram = _g.sent();
          return [4
          /*yield*/
          , shouldUseVirtualPayment({
            isMiniProgram: isInMiniProgram,
            applePayCfg: '',
            needShip: (_b = payload === null || payload === void 0 ? void 0 : payload.needShip) !== null && _b !== void 0 ? _b : false,
            price: (payload === null || payload === void 0 ? void 0 : payload.price) || 0,
            linkId: (payload === null || payload === void 0 ? void 0 : payload.linkId) || ''
          })];

        case 2:
          isVirtualPay = _g.sent();

          if (isVirtualPay) {
            params.platform = VIRTUAL_PAY_PLATFORM;
            params.app = VIRTUAL_PAY_APP;
          }

          _g.label = 3;

        case 3:
          _g.trys.push([3, 8,, 9]);

          Toast.load('请稍后', 15000);
          return [4
          /*yield*/
          , createOrder(params)];

        case 4:
          _c = _g.sent(), resultCode = _c.resultCode, data = _c.data, errorMsg = _c.errorMsg;
          if (!(resultCode === 200)) return [3
          /*break*/
          , 6];
          flagCode = data.flagCode, frontSoldNote = data.frontSoldNote, frontPayResp = data.frontPayResp, checkCode = data.checkCode;

          if (flagCode === 3) {
            _d = frontSoldNote || {}, id = _d.id, needShip = _d.needShip, _e = _d.courseId, courseId = _e === void 0 ? '' : _e, skuId = _d.skuId;
            Toast.successed('领取成功');

            if (needShip) {
              nsUrl = "/address/edit?cid=".concat(courseId || '', "&oid=").concat(id || '', "&sid=").concat(skuId, "&channelNo=").concat((payload === null || payload === void 0 ? void 0 : payload.channelNo) || '', "&linkId=").concat((payload === null || payload === void 0 ? void 0 : payload.linkId) || '', "&scene=INTRO&campId=").concat((payload === null || payload === void 0 ? void 0 : payload.campaignId) || '', "&cpId=").concat((payload === null || payload === void 0 ? void 0 : payload.campaignPageId) || '');
              urlJump(nsUrl, true);
              return [2
              /*return*/
              , true];
            }

            window.location.href = "".concat(TRANS_PAGE, "?scene=INTRO&oid=").concat(id, "&sid=").concat((payload === null || payload === void 0 ? void 0 : payload.skuId) || '', "&campId=").concat((payload === null || payload === void 0 ? void 0 : payload.campaignId) || '', "&cpId=").concat((payload === null || payload === void 0 ? void 0 : payload.campaignPageId) || '', "&linkId=").concat((payload === null || payload === void 0 ? void 0 : payload.linkId) || '');
            return [2
            /*return*/
            , true];
          }

          if (flagCode === 5) {
            _f = frontPayResp || {}, preOrderId = _f.preOrderId, soldId = _f.soldNoteId, payToken = _f.token;
            bus.emit('$nextTick', {
              nextAction: 'toPay',
              orderResult: {
                preOrderId: preOrderId,
                soldId: soldId,
                payToken: payToken,
                checkCode: checkCode,
                // SP122 新增sIndex参数，用于记录扩科时点击的sku索引，及标识下单场景
                sIndex: extra.signIndex || '',
                mode: extra.mode || ''
              }
            });
            return [2
            /*return*/
            , true];
          } // 异常code处理


          return [4
          /*yield*/
          , handleBuinessCode(data, payload, function () {})];

        case 5:
          // 异常code处理
          _g.sent();

          Toast.hide();
          return [3
          /*break*/
          , 7];

        case 6:
          Toast.warning(errorMsg || '系统异常', 1500);
          _g.label = 7;

        case 7:
          return [3
          /*break*/
          , 9];

        case 8:
          error_1 = _g.sent();
          console.log(error_1);
          Toast.hide();
          return [3
          /*break*/
          , 9];

        case 9:
          return [2
          /*return*/
          , false];
      }
    });
  });
}